export default __webpack_public_path__ + "static/media/Blue_Badge.c8dc9ec3.png";